import { proxy } from 'valtio';

export const campaignState = proxy({
  activeCampaign: null,
});
